import { BREAKPOINTS } from 'resources/constants'
import styled, { css } from 'styled-components'

export const InfoWrapper = styled.section`
	background-color: #f6f4f2;
	padding: 80px 15px 40px;
`

export const SectionContent = styled.article`
	max-width: 800px;
	margin: 0 auto 50px;
`

export const DressCodeContainer = styled.div`
	padding-top: 50px;
`

export const ItemTitle = styled.div`
	font-size: 1.3rem;
	margin-bottom: 20px;
	font-family: 'Trajan Pro', sans-serif;
`

export const ItemContainer = styled.div`
	display: flex;
	justify-content: flex-start;
	align-items: flex-start;
	margin-bottom: 20px;
	padding-left: 30px;
`

export const ItemIcon = styled.img`
	margin-right: 15px;
	height: 1.5rem;
`

export const ItemDescription = styled.div``

export const ExampleImageSection = styled.div`
	margin-bottom: 20px;
	display: flex;
	justify-content: center;
	align-items: center;
	@media only screen and (min-width: ${BREAKPOINTS.md}) {
		justify-content: flex-start;
		margin-bottom: -20px;
	}
`

const DressCodeImage = styled.img`
	width: auto;
	max-height: 220px;
`

export const DressImage = styled(DressCodeImage)`
	position: relative;
	@media only screen and (min-width: ${BREAKPOINTS.md}) {
		top: -60px;
		left: -30px;
	}
	@media only screen and (min-width: ${BREAKPOINTS.lg}) {
		top: -50px;
		left: -20px;
	}
`
export const SuitsImage = styled(DressCodeImage)`
	position: relative;
	@media only screen and (min-width: ${BREAKPOINTS.md}) {
		top: 20px;
		left: -40px;
	}
	@media only screen and (min-width: ${BREAKPOINTS.lg}) {
		top: 20px;
		left: -10px;
	}
`

export const AlertBox = styled.div`
	background-color: white;
	border: 1px solid hsl(351, 34%, 70%);
	color: hsl(351, 34%, 30%);
	padding: 0.75rem 1.25rem;
	border-radius: 6px;
	font-size: 0.875rem;
	width: fit-content;

	i {
		margin-right: 0.5rem;
	}
`

export const ImageIcon = styled.img`
	width: 30px;
	height: auto;
	margin-left: 5px;
`

const InstagramElement = css`
	font-family: 'Aveny T Web', sans-serif;
	text-transform: uppercase;
	background-color: #fff;
	padding: 4px 4px 1px;
	line-height: 1;
	border-radius: 8px;
	border: 1px solid #eee;
`

export const Hashtag = styled.span`
	${InstagramElement}
	color: #ff0167;
`

export const Tagging = styled.a`
	${InstagramElement}
	color: #fe7003;
	text-decoration: none;

	&:hover {
		color: #fe7003;
		opacity: 0.8;
	}
`
